// extracted by mini-css-extract-plugin
export default {"password":"ContainerSasToken_password__bDzCn","button":"ContainerSasToken_button__5GKyF","content_wrap":"ContainerSasToken_content_wrap__Y7VFS"};